import { buildColumn, EditableColumnConfig } from '~components/table-view';

const columnsFactory = () => {
  const columns: EditableColumnConfig[] = [
    {
      id: 'package_fixed.funding_type.name',
      header: 'Funding Type',
      type: 'text',
    },
    {
      id: 'start_date',
      header: 'Start Date',
      type: 'date',
    },
    {
      id: 'end_date',
      header: 'End Date',
      type: 'date',
    },
  ];

  return columns.map(buildColumn);
};

export default columnsFactory;
